import { SERVICES } from './data';
export default function Service() {
  return (
    <div className="bg-[#15141A] text-[#F4F1EA] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#FF6B1A]"><p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#FF6B1A] mb-3">— Workshop · On-site authentication & restoration</p><h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The workshop,<br />on the same site.</h1></section>
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-12 grid md:grid-cols-3 gap-px bg-[#2A2730]">
        {SERVICES.map((s, i) => (
          <article key={s.code} className="bg-[#1F1D24] p-8 lg:p-10 flex flex-col">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#FF6B1A] border-b border-[#2A2730] pb-2 mb-4">— Service {String(i + 1).padStart(2, '0')} · {s.code}</p>
            <h2 className="font-serif italic text-3xl text-[#F4F1EA]">{s.t}</h2>
            <p className="font-sans text-sm text-[#F4F1EA]/65 mt-3 leading-[1.7] flex-1">{s.d}</p>
            <div className="mt-5 flex items-baseline justify-between border-t border-[#2A2730] pt-4"><span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F4F1EA]/55">From</span><span className="font-serif text-2xl text-[#FF6B1A]">{s.from}</span></div>
          </article>
        ))}
      </section>
    </div>
  );
}
